import { ca } from '../i18n/ca';

/**
 * The ground under the samples by the engine's surface name, in words a person
 * reads: the names differ by terrain (`#GdtGrassGreen`, `#GdtForestMalden`), so
 * they are read by what they contain, and a name nothing matches is "Altres"
 * with the name in small print.
 */
const SURFACE_WORDS: [RegExp, string][] = [
  [/seabed|water/, 'water'],
  [/forest|wood|tree|pine|conifer|leaf/, 'forest'],
  [/grass|meadow|weed|green/, 'grass'],
  [/field|farm|crop|wheat|soil_?farm/, 'field'],
  [/concrete|asphalt|tarmac|pavement|road|cobble/, 'paved'],
  [/beach|sand/, 'sand'],
  [/desert|dust/, 'desert'],
  [/marsh|swamp|mud|bog/, 'marsh'],
  [/snow|ice/, 'snow'],
  [/rock|stone|stony|gravel|cliff|hard/, 'stone'],
  [/dirt|soil|ground|dry|earth|clay/, 'dirt'],
];
export function surfaceLabel(kind: string): { label: string; raw?: string } {
  const s = ca.terrainPage.sheet;
  if (!kind) return { label: s.otherSurface };
  const k = kind.toLowerCase();
  const hit = SURFACE_WORDS.find(([re]) => re.test(k));
  return hit
    ? { label: s.surfaces[hit[1]] ?? s.otherSurface }
    : { label: s.otherSurface, raw: kind.replace(/^#?gdt/i, '') };
}
